import { date, defineEntity, object, string, timestamps } from '~/prix'
import any from '~/prix/types/any'

const insightEntity = defineEntity({
  key: 'insight',
  title: 'Insight',
  sources: ['oltp'],
  schema: object({
    id: string().label('ID', 'Identificador', 'Código'),
    type: string().label('Tipo do Insight'),
    key: string().label('Chave do Insight'),
    startDate: date().label('Data de Início'),
    endDate: date().label('Data de Fim'),
    title: string().label('Título'),
    description: string().label('Descrição'),
    relevance: string().label('Relevância'),
    alertPreset: string().label('Predefinição de Alerta'),
    alertName: string().label('Nome do Alerta'),
    alertColor: string().label('Cor do Alerta'),
    alertHint: string().label('Dica do Alerta'),
    alertOutcome: string().label('Outcome do Alerta', 'normal', 'good', 'bad'),
    visualizations: any().label('Visualizações'),
    actions: any().label('Ações'),
    delimitationType: string().label('Tipo de Delimitação'),
    delimitationTitle: string().label('Título da Delimitação'),
    delimitationId: string().label('ID da Delimitação'),
    variableKey: string().label('Chave da Variável'),
    variablePresetKey: string().label('Chave da Predefinição da Variável'),
    variableTitle: string().label('Título da Variável'),
    variableLabel: string().label('Rótulo da Variável'),
    searchText: string().label('Texto de Busca'),
    ...timestamps,
  }),
})

export default insightEntity
